import { render, staticRenderFns } from "./Dashboard3.vue?vue&type=template&id=3418352c"
import script from "./Dashboard3.vue?vue&type=script&lang=js"
export * from "./Dashboard3.vue?vue&type=script&lang=js"
import style0 from "./Dashboard3.vue?vue&type=style&index=0&id=3418352c&prod&lang=scss"
import style1 from "./Dashboard3.vue?vue&type=style&index=1&id=3418352c&prod&media=screen%2C%20projection&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports